const BODY_SCROLL_SHELL_TOPIC = 'ESPP3.PDP.BodyScrollLock';

type ShellScrollLockDetail = {
    source: string;
    locked: boolean;
};

export class PDPBodyScrollLocker {
    static lock(source: string): void {
        window.shell.publishTo(BODY_SCROLL_SHELL_TOPIC, {
                detail: {
                    source,
                    locked: true
                } as ShellScrollLockDetail
            },
        );
    }

    static unlock(source: string): void {
        window.shell.publishTo(BODY_SCROLL_SHELL_TOPIC, {
                detail: {
                    source,
                    locked: false
                } as ShellScrollLockDetail
            },
        );
    }
}

